var render = function render() {
  var _vm = this,
      _c = _vm._self._c;return _c('el-cascader', _vm._g(_vm._b({ model: { value: _vm.formValue[_vm.innerConfig.prop], callback: function callback($$v) {
        _vm.$set(_vm.formValue, _vm.innerConfig.prop, $$v);
      }, expression: "formValue[innerConfig.prop]" } }, 'el-cascader', _vm.innerConfig.params, false), _vm.$listeners));
};
var staticRenderFns = [];

export { render, staticRenderFns };